import { Checkbox, Icon, Link } from '@fluentui/react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import { DataChampMetier } from '../../data/DataChampMetier';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheChampMetier } from '../Fiche/FicheChampMetier';
import { FichePublipostage } from '../Fiche/FichePublipostage';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListChampMetier extends Component {

    static defaultProps = {};

    static defaultState = {
        itemActif: {},
        items: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListChampMetier.defaultState };
        this._isSortedDescending = false;
        this._sortedColumn = "nomTable";
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this._togglePanel("Filtres", false, null, this._chargementDonnees)();
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des balises en cours'
        });

        const filtres = { ...this._filtres };

        DataChampMetier._lister(filtres, this._sortedColumn, this._isSortedDescending).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const items = responseFetch.reponseAPIobjet || [];
                const state = { items };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });

    };

    _getColumns = () => {

        let columns = [{
            key: "idChampMetier",
            minWidth: 20,
            maxWidth: 20,
            name: "",
            onRender: (item) => {
                const idChampMetier = item.idChampMetier;
                return <span title={idChampMetier} className="badge badge-secondary">{idChampMetier}</span>;
            }
        }, {
            iconName: "CheckboxComposite",
            isIconOnly: true,
            key: "checkbox",
            minWidth: 20,
            maxWidth: 20,
            onRender: (item) => item.checkbox && <Icon iconName="CheckboxComposite" />
        }, {
            key: "requeteSQL",
            maxWidth: 30,
            minWidth: 30,
            name: "SQL",
            onRender: (item) => {
                const requeteSQL = item.requeteSQL;
                return requeteSQL && <Link onClick={this._toggleDialog("SQL", true, item)}>SQL</Link>;
            }
        }, {
            isResizable: true,
            key: "tag",
            maxWidth: 300,
            minWidth: 300,
            name: "Balise",
            onRender: (item) => {
                const tags = this._getItemTags(item);
                return tags.map((tag, index) => <div key={index}>{tag}</div>);
            }
        }, {
            fieldName: "description",
            key: "description",
            name: "Description",
            isResizable: true,
        }, {
            fieldName: "exemple",
            isResizable: true,
            key: "exemple",
            maxWidth: 200,
            minWidth: 200,
            name: "Exemple",
        }, {
            key: "edition",
            name: "Edition",
            isIconOnly: true,
            minWidth: 20,
            maxWidth: 20,
            onRender: (item) => <IconButton
                iconProps={{ iconName: "Edit" }}
                onClick={this._togglePanel("ChampMetier", true, item)}
                title="Modifier le champ métier"
            />
        }, {
            key: "delete",
            name: "Delete",
            minWidth: 20,
            maxWidth: 20,
            iconName: "",
            isIconOnly: true,
            onRender: (item) => <IconButton
                iconProps={{ iconName: "Delete" }}
                onClick={this._toggleDialog("SuppressionChampMetier", true, item)}
                title="Supprimer la balise"
            />
        }];

        return columns;

    };

    _getFarItems = () => {
        return [{
            key: "nombreEnregistrement",
            name: this.state.items.length
        }, {
            key: 'filtre',
            name: 'Filtres',
            iconProps: { iconName: 'Filter' },
            iconOnly: true,
            onClick: this._togglePanel("Filtres", true)
        }];
    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {

        return [{
            key: "search",
            onRender: () =>
                <SearchBox
                    className="searchBox"
                    onClear={(e) => this._onSearch("")}
                    onSearch={value => this._onSearch(value)}
                    placeholder="Recherche rapide"
                />
        }, {
            key: "nouveau",
            name: "Nouvelle balise",
            iconProps: { iconName: "Add" },
            onClick: this._togglePanel("ChampMetier", true, { idChampMetier: 0 })
        }, {
            key: "test",
            name: "Effectuer un test",
            iconProps: { iconName: "TestBeaker" },
            onClick: this._togglePanel("Publipostage", true, { idChampMetier: 0 })
        }, {
            key: "informations",
            name: "Informations",
            iconProps: { iconName: "Info" },
            onClick: this._toggleDialog("Informations", true)
        }];

    };

    _getItemTags = (item) => {
        if (!!item) {
            const { libelleV2, libelleV4, nomChamp, nomTable, prefix } = item;
            let tags = [];
            if (!!nomChamp && !!prefix) tags.push(`${prefix}_${nomChamp}`);
            if (!!nomChamp && !!nomTable) tags.push(`${nomTable}_${nomChamp}`);
            if (!!libelleV4) tags.push(libelleV4);
            if (!!libelleV2) tags.push(libelleV2);
            return tags;
        }
    };

    _onRenderDetailsHeader(props, defaultRender) {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>;
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _supprimerChampMetier = (idChampMetier) => () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression en cours"
        });

        DataChampMetier._supprimer(idChampMetier).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _toggleDialog = (nomDialog, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {

        const {
            afficherDialogInformations, afficherDialogSQL, afficherDialogSuppressionChampMetier,
            afficherPanelChampMetier, afficherPanelFiltres, afficherPanelPublipostage,
            itemActif, items
        } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        <DetailsList
                            columns={this._columns}
                            items={items}
                            onColumnHeaderClick={this._onColumnHeaderClick}
                            onRenderDetailsHeader={this._onRenderDetailsHeader}
                            onRenderItemColumn={this._onRenderItemColumn}
                            selectionMode={SelectionMode.none}
                        />
                    </ScrollablePane>
                </div>
            </Stack>

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onValidate={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
            />

            <FichePublipostage
                isOpen={afficherPanelPublipostage}
                onDismiss={this._togglePanel("Publipostage", false)}
            />

            <FicheChampMetier
                idChampMetier={itemActif.idChampMetier}
                isOpen={afficherPanelChampMetier}
                onDismiss={this._togglePanel("ChampMetier", false)}
                onSave={this._togglePanel("ChampMetier", false, {}, this._chargementDonnees)}
            />

            <EUIDialog
                buttons={[<DefaultButton key="close" onClick={this._toggleDialog("SQL", false, itemActif)} text="Fermer" />]}
                isOpen={afficherDialogSQL}
                onDismiss={this._toggleDialog("SQL", false, itemActif)}
                titre={!!itemActif && this._getItemTags(itemActif).join(" / ")}
            >
                <p style={{ whiteSpace: "pre-wrap" }}>
                    {!!itemActif && !!itemActif.requeteSQL && itemActif.requeteSQL
                        .replace(/\s/g, " ")
                        .replace(/\(SELECT /g, "(\nSELECT ")
                        .replace(/\) AS /g, "\n) AS ")
                        .replace(/ FROM /g, "\nFROM ")
                        .replace(/ INNER /g, "\nINNER ")
                        .replace(/ WHERE /g, "\nWHERE ")
                        .replace(/ AND /g, "\nAND ")
                        .replace(/ OR /g, "\nOR ")
                        .replace(/ GROUP BY /g, "\nGROUP BY ")
                        .replace(/ ORDER BY /g, "\nORDER BY ")
                    }
                </p>
            </EUIDialog>

            <EUIDialog
                buttons={[<DefaultButton key="close" onClick={this._toggleDialog("Informations", false)} text="Fermer" />]}
                isOpen={afficherDialogInformations}
                maxWidth="90vw!important"
                onDismiss={this._toggleDialog("Informations", false)}
                titre="Informations"
            >
                <ul>
                    <li>On inscrit en dur dans le code quels objets métiers vont être publipostés lorsque l’on lance le publipostage d’un document</li>
                    <ul>
                        <li>Exemple : lorsqu’on demande le publipostage d’une Relance (BO) alors on publiposte les informations de la relance, mais on publiposte aussi les informations de la demande initiale, et de la réservation associée si la demande est rattachée à une réservation. C’est ce fonctionnement en cascade qui est codée en dur</li>
                        <li>On pourra rendre cette partie paramétrable dans un second temps, si cela s’avère nécessaire</li>
                    </ul>
                    <li>Lorsqu’un objet métier est publiposté, par défaut tous ses attributs sont disponibles au format Table_Colonne</li>
                    <ul>
                        <li>Dans l’ADV par exemple on publiposte la réservation ; on peut donc dans nos maquettes Word insérer les commentaires suivants :</li>
                        <ul>
                            <li>Reservation_DateReservation</li>
                            <li>Reservation_Remarques</li>
                            <li>etc.</li>
                        </ul>
                        <li>Tous les attributs sont publipostés dans un format par défaut qui dépend de son type :</li>
                        <ul>
                            <li>Booléen : Oui ou Non</li>
                            <li>Date : format date courte (ex : 06/10/2022)</li>
                            <li>Décimale :</li>
                            <ul>
                                <li>Si le nom de l’attribut contient Prix, Montant, Frais ou Loyer : format monétaire (ex : MontantTTCExigible = 35400.000 donnera 35 400,00 €)</li>
                                <li>Si le nom de l’attribut contient Pourcentage ou Taux : x100 arrondi à deux décimales (ex : 0.36666 donnera 36.67)</li>
                            </ul>
                            <li>Tous les autres types : la valeur inscrite en BDD</li>
                        </ul>
                    </ul>
                    <li>Il est toujours possible de publiposter un objet métier en personnalisant son préfixe. Dans l’ADV par exemple les parkings sont publipostés au format Parking_Numero (au lieu de Lot_Numero comme le voudrait la logique par défaut). Là encore les préfixes sont déterminés et codés en dur</li>
                    <li>On peut désormais indexer les objets métiers que l’on publiposte, c’est en particulier utilisé sur les acquéreurs d’une réservation, et les destinataires d’une demande ou d’une relance :</li>
                    <ul>
                        <li>Dans l’ADV, tous les acquéreurs sont publipostés (pas uniquement les deux premiers) au format Acquereur1_x ; Acquereur2_x ; etc.</li>
                        <li>Dans le BO, tous les destinataires sont publipostés au format Destinataire1_x ; Destinataire2_x ; etc.</li>
                    </ul>
                    <li>Il est désormais possible en BDD de déclarer des attributs supplémentaires dans la table ChampMetier. On peut :</li>
                    <ul>
                        <li>
                            Déclarer un champ calculé<br />
                            Exemple : on permet l’utilisation du champ Reservation_PrixTTC<br />
                            Le prix TTC de la réservation est calculé à la volée d’après la requête SQL renseignée en BDD : on peut dans les requêtes insérer des balises à l’image de ce qui est fait dans les indicateurs (@R pour l’IdReservation par exemple)
                        </li>
                        <li>
                            Reformater un champ<br />
                            Exemple : on demande le formatage du champs Operation_EngagementInitialCA au format monétaire ({"{0:C}"} transforme un Decimal au format monétaire)
                        </li>
                        <li>
                            Déclarer une case à cocher<br />
                            Exemple : Le champ Contact_SouhaiteRecevoirOffres sera publiposté sous forme d’une case à cocher (en remplacement du Oui/Non par défaut sur les Boolean)
                        </li>
                    </ul>
                    <li>Les tableaux sont plus compliqués à migrer et sont pour le moment déclarés en dur dans le code (financements, lots, stades)</li>
                    <li>Quelques autres champs calculés n’ont pas été migrés non plus car très compliqués à transposer sous forme d’une requêtes SQL :</li>
                    <ul>
                        <li>Exemples : Reservation_PrixTTCEnToutesLettres ; Reservation_PrixHTEnToutesLettres</li>
                    </ul>
                </ul>
            </EUIDialog>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionChampMetier", false, {}, this._supprimerChampMetier(itemActif.idChampMetier))} text="Supprimer" />,
                ]}
                isOpen={afficherDialogSuppressionChampMetier}
                onDismiss={this._toggleDialog("SuppressionChampMetier", false)}
                titre="Suppression"
            >
                Confirmez-vous la suppression de cette balise ?
            </EUIDialog>

        </Fragment>;
    }
};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        params: {},
    };

    static defaultState = {
        checkboxesOnly: false,
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { checkboxesOnly } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <Checkbox
                checked={checkboxesOnly}
                label="Cases à cocher uniquement"
                onChange={(e, isChecked) => this.setState({ checkboxesOnly: isChecked })}
                styles={{ root: { marginTop: "8px" } }}
            />

        </EUIPanel>;

    };

};